export default __webpack_public_path__ + "static/media/waves_multiple.0ad7b309.svg";